import { render, staticRenderFns } from "./funcionarios.vue?vue&type=template&id=008b75ee&"
import script from "./funcionarios.vue?vue&type=script&lang=js&"
export * from "./funcionarios.vue?vue&type=script&lang=js&"
import style0 from "./funcionarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports